import { Pipe, PipeTransform } from '@angular/core';
import { ShipmentReferences } from '../../../pages/overview/models/overview';

@Pipe({
  name: 'hasReferences',
  standalone: true
})
export class HasReferencesPipe implements PipeTransform {
  transform(references: ShipmentReferences | null): boolean {
    if (!references) {
      return false;
    }
    return references.some(ref => !!ref);
  }
}
